const FILTER_TYPES = {
	BINDINGS: 'Bindings Filters',
	GROUPS: 'Groups Filters',
	STUDY_SET: 'Study Set Filters',
	UNCOLLECTED_INDEX: 'Uncollected Index Filters'
}

Object.freeze(FILTER_TYPES)
export default FILTER_TYPES
